import type { DisplayMode } from '@/types/book';

export type FoldCommitInput = {
  positionX: number;
  positionY: number;
  pageWidth: number;
  pageHeight: number;
  displayMode: DisplayMode;
  reverseBack: boolean;
};

export function shouldCommitFold({
  positionX,
  positionY,
  pageWidth,
  pageHeight,
  displayMode,
  reverseBack
}: FoldCommitInput): boolean {
  if (reverseBack) return positionX >= pageWidth / 2;
  if (displayMode === 'single') {
    const cornerGuardDistance = Math.max(Math.hypot(pageWidth, pageHeight) / 8, 100);
    const outsideCornerGuards =
      positionY >= cornerGuardDistance && positionY <= pageHeight - cornerGuardDistance;

    return outsideCornerGuards || positionX <= pageWidth * 0.7;
  }
  return positionX <= pageWidth / 3;
}
